<!--
 * @name: 输入框
 * @description: 登录输入框 
 * @author: huizi(huizi.li@shengyc.com)
 * @Date: 2020-04-22 16:02:05
 * @LastEditTime: 2021-06-03 15:06:47
 -->
<template>
  <div>
    <div class="area_code_box" @click="$_getAreaCode" v-if="areaCode">
      <span class="plus">+</span>
      <input class="area_code_input" type="number" :value="tel || '86'" readonly="readonly" />
      <span class="area_code_box_img"></span>
      <span class="area_code_line"></span>
    </div>
    <!-- <div class="area_code_box" @click="$_getPhone" v-else-if="left_icon">
      <span class="left_icon" />
      <input class="right_input" type="number" :placeholder="placeholderText" />
    <!-- <span class="input_again_time">30s后可重新获取</span>-->
    <!-- </div>
    <div class="area_code_box" @click="$_getPhone" v-else>
      <input class="phone_input" type="number" :placeholder="placeholderText" />
    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    tel: {
      type: String
    },
    areaCode: {
      type: Boolean
    },
    placeholderText: {
      type: String
    },
    left_icon: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    $_getAreaCode() {
      this.$emit('clickItemAreaCode');
    },
    $_getPhone() {}
  }
};
</script>

<style lang="scss">
@import '../../../assets/style/mixin';
.area_code_box {
  display: flex;
  flex-direction: row;
  // height: vw(20);
  // border-right: vw(1) #EEEEEE solid;
  @include fja(center, center);
  .plus {
    color: #666;
    font-size: vw(14);  
  }
  .area_code_input {
    width: vw(50);
    padding: 0 vw(2);
    color: #666;
    font-size: vw(14);
    margin-right: vw(-8);
    // background-color: red;
  }
  .area_code_box_img {
    display: block;
    @include wh(vw(20), vw(12));
    background: transparent url('../../../assets/images/ic_anArrow.png')
      no-repeat center center;
    background-size: vw(10), vw(6);
  }
  .area_code_line{
    height: vw(15);
    width: vw(1);
    margin: vw(5);
    background: #ccc;
  }
  .left_icon {
    display: block;
    @include wh(vw(28), vw(28));
    background: transparent
      url('../../../assets/images/ic_verification_code.png') no-repeat center
      center;
    background-size: vw(28), vw(28);
  }
  .right_input {
    padding-left: vw(13);
    color: #333;
    font-size: vw(18);
  }
  .right_input::-webkit-input-placeholder {
    color: #999;
  }
  .phone_input {
    // padding-left: vw(6);
    // padding-right: vw(5);
    // // height: vw(40);
    // flex: 1;
    // font-size: vw(18);
    border-left: vw(1) #999 solid;
    padding-left: vw(13);
    color: #1461ff;
    font-size: vw(18);
    // paddingVertical: 0
  }
  .input_again_time {
    color: #999;
    // font-size: vw(14);
  }
  .phone_input::-webkit-input-placeholder {
    color: #1461ff;
  }
}
</style>
